// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteHydrantRequestModel from '../../model/delete-hydrant-request-model';
import DeleteHydrantRequestDTO from '../dto/delete-hydrant-request-dto';
import dtoSchema from '../schemas/delete-hydrant-request-schema';

export default abstract class DeleteHydrantRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteHydrantRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteHydrantRequestDTO>): DeleteHydrantRequestModel;
  static toModel(dto: DeepPartial<DeleteHydrantRequestDTO> | undefined | null): DeleteHydrantRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteHydrantRequestDTO> | undefined | null): DeleteHydrantRequestModel | undefined {
    return dto ? new DeleteHydrantRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteHydrantRequestModel> | DeleteHydrantRequestModel): DeleteHydrantRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteHydrantRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteHydrantRequestModel, can not map to DeleteHydrantRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
